import {
    FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE, FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS, FETCH_PORTFOLIO_CASH_SUCCESS, FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS, FETCH_PORTFOLIO_CURRENCY_SUCCESS, FETCH_PORTFOLIO_DETAIL_BEGIN, FETCH_PORTFOLIO_DETAIL_FAILURE, FETCH_PORTFOLIO_DETAIL_SUCCESS, FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS, FETCH_PORTFOLIO_EXPENSE_SUCCESS, FETCH_PORTFOLIO_LIST_BEGIN, FETCH_PORTFOLIO_LIST_FAILURE, FETCH_PORTFOLIO_LIST_SUCCESS, FETCH_PORTFOLIO_MANAGER_SUCCESS, FETCH_PORTFOLIO_TAXSTATUS_SUCCESS, FETCH_PORTFOLIO_TYPE_SUCCESS,
FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS,
    FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE, FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS,
    FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE

} from '../constants/portfolio';

const initialState={
    portfolioList:[],
    isPortfolioLoading:false,
    errorLoadingPortfolioList:null,
    portfolio:{},
    isPortfolioDetailLoading:false,
    errorLoadingPortfolioDetail:null,
    discretionaryStatus:[],
    taxStatus:[],
    manager:[],
    creditFacility:[],
    expense:[],
    cash:[],
    currency:[],
    type:[],
    portfolioAccount: [],
    TOCash: [],
    Noncashaccounts: [],
}


export const portfolioReducer = (state=initialState,action) => {

    const { type, payload } = action;
    switch (type) {
        case FETCH_PORTFOLIO_LIST_BEGIN: 
            return {
                ...state,
                isPortfolioLoading: true,
                errorLoadingPortfolioList: null,
                portfolioList:[]
            };
        case FETCH_PORTFOLIO_LIST_FAILURE:
            return {
                ...state,
                isPortfolioLoading: false,
                portfolioList: [],
                errorLoadingPortfolioListL:payload.errorMessage
            };
        case FETCH_PORTFOLIO_LIST_SUCCESS:
            return {
                ...state,
                portfolioList: payload.portfolioList,
                errorLoadingPortfolioList: null,
                isPortfolioLoading: false
            };
        case FETCH_PORTFOLIO_DETAIL_BEGIN:
            return {
                ...state,
                isPortfolioDetailLoading: true,
                errorLoadingPortfolioDetail: null,
                portfolio:{}
            };
        case FETCH_PORTFOLIO_DETAIL_FAILURE:
            return {
                ...state,
                isPortfolioDetailLoading: false,
                portfolio: {},
                errorLoadingPortfolioListL:payload.errorMessage
            };
        case FETCH_PORTFOLIO_DETAIL_SUCCESS:
            return {
                ...state,
                portfolio: payload.Portfolio,
                errorLoadingPortfolioDetail: null,
                isPortfolioDetailLoading: false
            };
        case FETCH_PORTFOLIO_TYPE_SUCCESS:
            return {
                ...state,
                type: payload.Type
            };
        case FETCH_PORTFOLIO_CURRENCY_SUCCESS:
            return {
                ...state,
                currency: payload.Currency
            };
        case FETCH_PORTFOLIO_CASH_SUCCESS:
            return {
                ...state,
                cash: payload.Cash
            };
        case FETCH_PORTFOLIO_EXPENSE_SUCCESS:
            return {
                ...state,
                expense: payload.Expense
            };
        case FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS:
            return {
                ...state,
                creditFacility: payload.CreditFacility
            };
        case FETCH_PORTFOLIO_MANAGER_SUCCESS:
            return {
                ...state,
                manager: payload.Manager
            };
        case FETCH_PORTFOLIO_TAXSTATUS_SUCCESS:
            return {
                ...state,
                taxStatus: payload.TaxStatus
            };
        case FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS:
            return {
                ...state,
                discretionaryStatus: payload.DiscretionaryStatus
            };
        case FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN:
            return {
                ...state,
                portfolioAccount: []
            };
        case FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS:
            return {
                ...state,
                portfolioAccount: payload.PortfolioAccountList
            };
        case FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE:
            return {
                ...state,
                portfolioAccount: []
            };
        case FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN:
            return {
                ...state,
                TOCash: []
            };
        case FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS:
            return {
                ...state,
                TOCash: payload.TOCash
            };
        case FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE:
            return {
                ...state,
                TOCash: []
            };
        case FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN:
            return {
                ...state,
                Noncashaccounts: []
            };
        case FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS:
            return {
                ...state,
                Noncashaccounts: payload.Noncashaccounts
            };
        case FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE:
            return {
                ...state,
                Noncashaccounts: []
            };


        default:
            return state;
    }
}

export default portfolioReducer